export function eventsHandler({
  linkElement,
  show,
  hide,
}: {
  linkElement: HTMLElement;
  show: Function;
  hide: Function;
}) {
  let enterPopoverBeforeTimeout: number;
  let showingPopoverHandler: number;
  let handleMovingInsideOutsidePopover: number;
  const timeToComebackInsidePopover = 200;
  const timeBeforeClosingPopover = 300;
  const timeToStayOnTheLink = 300;
  const debugEvents = {
    enterPopover: 0,
    leavePopover: 0,
  };
  let isOpen = false;
  let alreadyVisited = false;
  let popoverElement: HTMLElement;

  linkElement.addEventListener('mouseover', onLinkEnter);
  linkElement.addEventListener('mouseleave', onLinkLeave);

  function onLinkEnter() {
    if (!isOpen) {
      showingPopoverHandler = window.setTimeout(
        onShowHook,
        timeToStayOnTheLink,
      );
    }
  }

  function onLinkLeave() {
    clearTimeout(showingPopoverHandler);
    if (isOpen && !alreadyVisited) {
      enterPopoverBeforeTimeout = window.setTimeout(
        onCloseHook,
        timeBeforeClosingPopover,
      );
    }
  }

  function onCloseHook() {
    isOpen = false;
    alreadyVisited = false;
    unbindPopoverEnterHandler();
    unbindPopoverLeaveHandler();
    hide(); // order matters - hide after unbind event
  }

  function onShowHook() {
    isOpen = true;
    show(updatePopoverElement); // order matters - show before bind event
    bindPopoverEnterHandler();
    bindPopoverLeaveHandler();
  }

  function updatePopoverElement(element: HTMLElement) {
    popoverElement = element;
  }

  function onPopoverEnter() {
    alreadyVisited = true;
    clearTimeout(handleMovingInsideOutsidePopover);
    clearTimeout(enterPopoverBeforeTimeout);
  }

  function onPopoverLeave() {
    handleMovingInsideOutsidePopover = window.setTimeout(
      onCloseHook,
      timeToComebackInsidePopover,
    );
  }

  function bindPopoverEnterHandler() {
    debugEvents.enterPopover += 1;
    popoverElement.addEventListener('mouseover', onPopoverEnter);
  }
  function bindPopoverLeaveHandler() {
    debugEvents.leavePopover += 1;
    popoverElement.addEventListener('mouseleave', onPopoverLeave);
  }
  function unbindPopoverEnterHandler() {
    debugEvents.enterPopover -= 1;
    popoverElement.removeEventListener('mouseover', onPopoverEnter);
  }
  function unbindPopoverLeaveHandler() {
    debugEvents.leavePopover -= 1;
    popoverElement.removeEventListener('mouseleave', onPopoverLeave);
  }
}
